module.exports = __webpack_public_path__ + "img/logo_rectangle.a062198e.png";